import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import { Link, SidebarModal } from '@domain-group/suit-theme'

import { useRelations as useUserRelations } from '@hooks/useUser'

import type { UserModel } from '@models/types'

interface SelectedRecipientProps {
  callbacks: {
    toggleUser: (arg: UserModel) => void,
  },
  user: UserModel,
}

const SelectedRecipient = (props: SelectedRecipientProps) => {
  const { user, callbacks: { toggleUser } } = props

  const { id, full_name, email } = user

  const { image } = useUserRelations(user)

  return (
    <SidebarModal.User
      disableHover
      // @ts-expect-error TS2339
      imageUrl={image.square_url}
      key={id}
      title={full_name}
      subtitle={email || 'No Email'}
    >
      <Link greyLink onClick={() => toggleUser(user)} textProps={{ fontSize: 'small' }}>
        <FontAwesomeIcon icon={faTrashAlt} />
      </Link>
    </SidebarModal.User>
  )
}

export default SelectedRecipient
